// src/pages/ProductDetail.js
// src/pages/ProductDetail.js
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ProductDetail.css';
import { motion, AnimatePresence } from 'framer-motion';
const productData = {
  homes: {
    title: 'Homes',
    projects: [
      
        {
        slug: 'homes4',
        name: 'SDA',
        thumbnail: '/ourproducts/sda/2.jpg',
        images: [1, 2, 3, 4, 5].map(n => `/ourproducts/sda/${n}.jpg`),
        description: 'A bespoke residence designed and built for Mr. Prem Singh Rana.',

      },
      {
        slug: 'homes2',
        name: 'NFC',
        thumbnail: '/ourproducts/nfc.jpg',
        images: ['/ourproducts/nfc.jpg'],
        description: 'A bespoke residence designed and built for Mrs. Bagheria.',

      },
     
          {
        slug: 'homes3',
        name: 'Vasant Vihar',
        thumbnail: '/ourproducts/upcoming.png',
        images: ['/ourproducts/up.png'],
        // description: '4.5 BHK Sample Apartment with stunning interior and FF&E design detailing and execution',

      },
    ],
  },
  'experience-center': {
    title: 'Experience Center',
    projects: [
      {
        slug: 'exp',
        name: 'One DXP, SmartWorld Sales Gallery 111',
        thumbnail: '/ourproducts/SmartWorldonedxp.png',
        images: [1, 2, 3, 4, 5, 6, 7, 8].map(n => `/ourproducts/onedxpp/${n}.jfif`),
        description: 'State of the art, grand and stunning sales gallery and experience center spread over two levels for One DXP project and other Smartworld projects in the vicinity.',

      },
      {
        slug: 'exp2',
        name: 'AU Real Estate',
        thumbnail: '/ourproducts/AURealestate.png',
        images: [1, 2, 3, 4, 5, 6, 7, 8].map(n => `/ourproducts/AUrealestate/AURealEstate/${n}.jfif`),
        description: ' Elegant, luxurious and inviting new sales gallery at Aditya World City for the new project launch.',

      },
      {
        slug: 'exp3',
        name: 'Trevoc Sales Gallery',
        thumbnail: '/ourproducts/TREVOCLogo.jpg',
        images: [
          '/ourproducts/Trevoc/Trevoc/1.png',
          '/ourproducts/Trevoc/Trevoc/2.jfif',
          '/ourproducts/Trevoc/Trevoc/3.jfif',
          '/ourproducts/Trevoc/Trevoc/4.jfif',
          '/ourproducts/Trevoc/Trevoc/5.jfif',
          '/ourproducts/Trevoc/Trevoc/6.jfif',
          '/ourproducts/Trevoc/Trevoc/7.jfif',
          
        ],
        description: 'Proposed Sales Gallery in Gurgaon',
      },
     
      {
        slug: 'exp5',
        name: 'ASF Experience Centre',
        thumbnail: '/ourproducts/ASFLogo.jfif',
        images: [
          '/ourproducts/ASF/ASF/1.png',
          '/ourproducts/ASF/ASF/2.jfif',
        ],
        description: 'Sales experience center for ASF in Gurgaon',
      },
    ],
  },
  offices: {
    title: 'Offices',
    projects: [
      {
        slug: 'offices1',
        name: 'Filatex Corporate Office',
        thumbnail: '/ourproducts/FILATEX.png',
        images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(n => `/ourproducts/Filatex/Filatex/${n}.jfif`),
        description: 'Elegance, understated luxury and functionality defined the design and build of this new corporate office for Filatex',
      },
      {
        slug: 'offices2',
        name: 'Upgrad',
        thumbnail: '/ourproducts/Upgrad.png',
        images: [1, 2, 3, 4, 5, 6, 7].map(n => `/ourproducts/UpGrad/UpGrad/${n}.jfif`),
        description: 'Bright, cheerful, colourful and functional interiors for a very young workforce with a very high density of workstations.',
      },
      {
        slug: 'offices3',
        name: 'ACS',
        thumbnail: '/ourproducts/ACSlogo.jfif',
        images: [1, 2, 3, 4, 5, 6].map(n => `/ourproducts/ACS/${n}.jfif`),
        description: ' Complete building interiors with a different design concept for every floor in NOIDA for a global giant consulting firm',
      },
      {
        slug: 'offices4',
        name: 'BMR Advisors',
        thumbnail: '/ourproducts/BMRlogo.jpg',
        images: [1, 2, 3, 4].map(n => `/ourproducts/BMRAdvisors/BMRAdvisors/${n}.jfif`),
        description: 'Elegant Corporate office for a prestigious consulting firm acquired by Deloitte',
      },
      {
        slug: 'offices5',
        name: 'Interocean',
        thumbnail: '/ourproducts/interOCEAN.jpg',
        images: [1, 2, 3, 4, 5].map(n => `/ourproducts/InterOcean/InterOcean/${n}.jfif`),
        description: 'Corporate office for a renowned shipping company in New Delhi ',
      },
      {
        slug: 'offices6',
        name: 'IFLY | Indigo',
        thumbnail: '/ourproducts/Indigo.png',
        images: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].map(n => `/ourproducts/IFlyIndigo/${n}.jfif`),
        description: 'New and state of the art training facility for Indigo Airlines with stunning interiors ',
      },
      {
        slug: 'offices7',
        name: 'Quickr Campus',
        thumbnail: '/ourproducts/Quikrlogo.png',
        images: [
          '/ourproducts/QuikrCampus/QuikrCampus/1.png',
          '/ourproducts/QuikrCampus/QuikrCampus/2.jfif',
          '/ourproducts/QuikrCampus/QuikrCampus/3.jfif',
          '/ourproducts/QuikrCampus/QuikrCampus/4.jfif',
          '/ourproducts/QuikrCampus/QuikrCampus/5.jfif',
          '/ourproducts/QuikrCampus/QuikrCampusevoc/6.jfif',
          '/ourproducts/QuikrCampus/QuikrCampus/7.jfif',
          '/ourproducts/QuikrCampus/QuikrCampus/8.jfif',
          '/ourproducts/QuikrCampus/QuikrCampus/9.jfif',
        ],
        description: 'Redevelopment of an old factory with amazing ceiling heights into the new corporate headquarters for Quikr.',
      },
      {
        slug: 'offices8',
        name: 'BloomBerg Quint',
        thumbnail: '/ourproducts/bloomberglogo.jpg',
        images: [1, 2, 3, 4, 5].map(n => `/ourproducts/BloombergQuint/BloombergQuint/${n}.jfif`),
        description: 'New floor for Bloomberg Quint in Mumbai with studios, post production facilities and youthful interiors',
      },
      {
        slug: 'offices9',
        name: 'The Quint',
        thumbnail: '/ourproducts/quint.png',
        images: [1, 2, 3, 4, 5].map(n => `/ourproducts/ThQuint/${n}.jfif`),
        description: 'Young, dynamic, eclectic interiors for The Quint in Noida',
      },
    ],
  },

    sample: {
    title: 'Sample apartments',
    projects: [
      {
        slug: 'Sample1',
        name: 'Smart World',
        thumbnail: '/ourproducts/Smartworld.jfif',
        images: [1, 2, 3, 4].map(n => `/ourproducts/smartworldsample/${n}.jfif`),
        description: '4.5 BHK Sample Apartment with stunning interior and FF&E design detailing and execution',

      },
        {
        slug: 'sample2',
        name: 'M3M Sales Gallery',
        thumbnail: '/ourproducts/M3M.png',
        images: [1, 2, 3, 4, 5, 6, 7, 8].map(n => `/ourproducts/M3M/${n}.jfif`),
        description: '4.5 BHK Sample Apartment with bespoke interior and FF&E design detailing and execution',
      },
       {
        slug: 'sample3',
        name: 'Upcoming',
        thumbnail: '/ourproducts/upcoming.png',
        images: ['/ourproducts/up.png'],
        // description: '4.5 BHK Sample Apartment with stunning interior and FF&E design detailing and execution',

      },
     
    ],
  },
};


export default function ProductDetail() {
  const { slug } = useParams();
  const data = productData[slug];
  const [activeProjectIndex, setActiveProjectIndex] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideIndex((i) =>
        (i + 1) % (data?.projects?.[activeProjectIndex]?.images?.length || 1)
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [activeProjectIndex, data]);

  if (!data) {
    return (
<div className='wrap'>
      <video className="backvideo" autoPlay muted loop playsInline>
    <source src="/backvid.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>        <Navbar />
        <main className="pd-container container">
          <h2>Category not found</h2>
        </main>
        <Footer />
        </div>
    );
  }

  const { title, projects } = data;
  const project = projects[activeProjectIndex];
  const slides = project.images;

  const prevSlide = () =>
    setSlideIndex((i) => (i - 1 + slides.length) % slides.length);
  const nextSlide = () => setSlideIndex((i) => (i + 1) % slides.length);

  return (
<div className='wrap'>
      <video className="backvideo" autoPlay muted loop playsInline>
    <source src="/backvid.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>       <Navbar />
      <main className="pd-container container">

<motion.h2
  className="portfolio-header text-center"
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
>
  {title}
</motion.h2>

        {/* ► Slideshow */}
        <div className="slideshow-container">
          <button className="nav-btn prev" onClick={prevSlide}>❮</button>
          <img
            src={slides[slideIndex]}
            alt={`${project.name} slide ${slideIndex + 1}`}
            className="slide-img"
          />
          <button className="nav-btn next" onClick={nextSlide}>❯</button>
        </div>

        {/* ► Thumbnails */}
        <div className="thumb-strip">
          {projects.map((p, idx) => (
            <motion.button
              key={p.slug}
              className={`thumb ${activeProjectIndex === idx ? 'active' : ''}`}
              onClick={() => {
                setActiveProjectIndex(idx);
                setSlideIndex(0);
              }}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
            >
              <div className="thumb-wrapper">
                <img src={p.thumbnail} alt={p.name} />
                <div className="thumb-overlay">{p.name}</div>
              </div>
            </motion.button>
          ))}
        </div>

        <div className="project-desc">{project.description}</div>
      </main>
      <Footer />
    </div>
  );
}